export default {"src":"/_next/static/media/archive-gray-logo.8c920a95.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};